import { DifficultyLevel } from '../../utils/advancedMultiplication';

interface DifficultySelectorProps {
  currentLevel: DifficultyLevel;
  onSelectLevel: (level: DifficultyLevel) => void;
}

const difficultyInfo = {
  beginner: {
    title: 'Beginner',
    description: 'Practice with basic multiplication tricks and tables (1-20)',
    gradient: 'from-teal-600 to-emerald-600',
    darkGradient: 'dark:from-teal-500 dark:to-emerald-500',
    hover: 'hover:from-teal-700 hover:to-emerald-700',
    darkHover: 'dark:hover:from-teal-600 dark:hover:to-emerald-600'
  },
  intermediate: {
    title: 'Intermediate',
    description: 'Challenge yourself with double-digit multiplications and tables (21-99)',
    gradient: 'from-blue-600 to-indigo-600',
    darkGradient: 'dark:from-blue-500 dark:to-indigo-500',
    hover: 'hover:from-blue-700 hover:to-indigo-700',
    darkHover: 'dark:hover:from-blue-600 dark:hover:to-indigo-600'
  },
  expert: {
    title: 'Expert',
    description: 'Master complex multiplications and advanced tables (101-999)',
    gradient: 'from-violet-600 to-purple-600',
    darkGradient: 'dark:from-violet-500 dark:to-purple-500',
    hover: 'hover:from-violet-700 hover:to-purple-700',
    darkHover: 'dark:hover:from-violet-600 dark:hover:to-purple-600'
  }
};

export const DifficultySelector: React.FC<DifficultySelectorProps> = ({
  currentLevel,
  onSelectLevel,
}) => {
  return (
    <div className="mb-8">
      <h3 className="text-xl font-bold mb-4 text-gray-800 dark:text-gray-200">Select Difficulty Level</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {(Object.keys(difficultyInfo) as DifficultyLevel[]).map((level) => (
          <button
            key={level}
            onClick={() => onSelectLevel(level)}
            className={`p-4 rounded-lg transition-all ${
              currentLevel === level
                ? `bg-gradient-to-r ${difficultyInfo[level].gradient} ${difficultyInfo[level].darkGradient} text-white`
                : 'bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200'
            } border border-gray-200 dark:border-gray-700`}
          >
            <h4 className="text-lg font-semibold mb-2">{difficultyInfo[level].title}</h4>
            <p className={`text-sm ${
              currentLevel === level
                ? 'text-white/90'
                : 'text-gray-600 dark:text-gray-400'
            }`}>
              {difficultyInfo[level].description}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
}